import { action, makeObservable, observable, runInAction } from "mobx";
import EmailerAPI from "../api/EmailerAPI";
import { VoucherDetail } from "../../../models/Vouchers/VoucherDetail";
import { VoucherEmailerFilters } from "../../../models/Vouchers/VoucherEmailerFilters";
import { PaginatedAPIResponse } from "../../../models/NetworkResponse";

export class EmailerStore {
  emailerAPI: EmailerAPI;
  voucherEmailers: VoucherDetail[] = [];
  limit: number = 0;
  total_count: number = 0;
  total_pages: number = 0;

  constructor() {
    this.emailerAPI = new EmailerAPI();

    makeObservable(this, {
      voucherEmailers: observable,
      limit: observable,
      total_count: observable,
      total_pages: observable,
      getVoucherEmailers: action,
    });
  }

  getVoucherEmailers = async (filters: VoucherEmailerFilters) => {
    try {
      const response = (await this.emailerAPI.getVoucherEmailers(
        filters,
      )) as PaginatedAPIResponse<VoucherDetail>;
      runInAction(() => {
        this.limit = response.limit;
        this.total_count = response.total_count;
        this.total_pages = response.total_pages;
        this.voucherEmailers = response.list;
      });
    } catch (error: any) {
      throw error;
    }
  };
}
